var $c8e2288226c24a67$exports = {};
$c8e2288226c24a67$exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "V\xE6rdien skal v\xE6re ".concat(args.maxValue, " eller tidligere.");
  },
  "rangeReversed": "Startdatoen skal v\xE6re f\xF8r slutdatoen.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "V\xE6rdien skal v\xE6re ".concat(args.minValue, " eller nyere.");
  },
  "unavailableDate": "Den valgte dato er ikke tilg\xE6ngelig."
};
export { $c8e2288226c24a67$exports as default };